<template>
	<div class="christmas-offer-goal">
		<h2>{{ t('offers.christmas.pre.goal.reach_your_goal', { name }) }}</h2>
		<h1>{{ t('offers.christmas.pre.goal.goal', { weight, date }) }}</h1>
		<ChristmasOfferRibbon :font-size="fontSize">
			{{ t('offers.christmas.pre.goal.ribbon_text') }}
		</ChristmasOfferRibbon>
	</div>
</template>

<style lang="scss" scoped>
.christmas-offer-goal {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 2.2rem;

	h2 {
		margin-top: 0;
		margin-bottom: 0.25rem;
		font-size: 1.4rem;
		letter-spacing: -0.02em;
		font-weight: 700;
		color: #323653;
		line-height: 1.2;
		text-align: center;
	}

	h1 {
		margin-top: 0;
		margin-bottom: 0.25rem;
		font-size: 2rem;
		font-weight: 900;
		color: #323653;
		line-height: 1.2;
		text-align: center;
	}
}

[lang='de'] {
	.christmas-offer-goal {
		h1 {
			font-size: 1.8rem;
		}
	}
}
</style>

<script>
import { computed } from '@vue/reactivity'
import { addDays, format } from 'date-fns'
import { useI18n } from 'vue-i18n'
import ChristmasOfferRibbon from './ChristmasOfferRibbon.vue'
import useApi from '@/composition/api'
import { mapI18nToDateFnsLocale, mapI18nToDateFnsFormat } from '@/utils/i18nDateFnsHelper.js'

export default {
	name: 'ChristmasOfferGoal',
	props: {
		name: {
			type: String,
			default: 'Alex'
		},
		targetWeight: {
			type: Number,
			default: 70
		},
		daysToGoal: {
			type: Number,
			default: 0
		},
		isMetric: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const api = useApi()
		const lang = api.getLanguage()
		const { t } = useI18n()
		const weight = computed(
			() =>
				`${Math.trunc(props.isMetric ? props.targetWeight : props.targetWeight * 2.205).toString()} ${
					!props.isMetric ? t('lbs') : t('kg')
				}`
		)

		const date = computed(() => {
			return format(addDays(Date.now(), props.daysToGoal), mapI18nToDateFnsFormat(lang), {
				locale: mapI18nToDateFnsLocale(lang)
			})
		})

		return {
			t,
			weight,
			date,
			fontSize: computed(() => (lang === 'en' ? '1.5rem' : '1.2rem'))
		}
	},
	components: { ChristmasOfferRibbon }
}
</script>
